import { useQuery } from "@tanstack/react-query";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import { AudioReader } from "@/components/AudioReader";
import { ShareButton } from "@/components/ShareButton";

export default function BlogPost() {
  const { slug } = useParams();
  const { data: post, isLoading, isError } = useQuery({
    queryKey: ["blog", slug],
    queryFn: () => api.get(`/blogs/${slug}`).then((r) => r.data),
  });

  if (isLoading) return <div className="pt-40 text-center font-mono text-sm text-muted-foreground">Loading…</div>;
  if (isError || !post) return (
    <div className="pt-40 text-center">
      <p className="font-mono text-sm text-muted-foreground">Article not found.</p>
      <Link to="/blog" className="mt-4 inline-block font-mono text-xs uppercase tracking-widest text-cyan">Back to Journal</Link>
    </div>
  );

  return (
    <article className="pt-32">
      <div className="container-px mx-auto max-w-[860px] pb-24" data-testid="blog-post">
        <Link to="/blog" className="mb-10 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-cyan">
          <ArrowLeft className="h-4 w-4" /> Journal
        </Link>
        <span className="font-mono text-[10px] uppercase tracking-widest text-cyan">{post.category} · {post.read_time} read</span>
        <h1 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] text-foreground md:text-6xl">{post.title}</h1>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <AudioReader text={`${post.title}. ${post.content.replace(/\n+/g, ". ")}`} testid="blog-audio" />
          <ShareButton title={post.title} url={typeof window !== "undefined" ? window.location.href : ""} note={post.excerpt}
            label="Share article" testid="blog-share"
            className="border border-border px-4 py-3 text-muted-foreground hover:border-foreground hover:text-foreground" />
        </div>
        {post.cover_image && <img src={post.cover_image} alt={post.title} className="mt-10 aspect-[16/9] w-full object-cover" />}
        <div className="mt-10 space-y-6 text-lg leading-relaxed text-muted-foreground">
          {post.content.split("\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </article>
  );
}
